import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-align_back_and_forth",
  "use": "icon-align_back_and_forth-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-align_back_and_forth\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M6,6H18V7.5H6Zm0,5H18V9.5H6Zm0,3.5H18V13H6ZM6,18H18V16.5H6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol